import React, { useEffect, useMemo } from "react";

import ContentLayout from "Components/ContentLayout";
import Loading from "ds/PageLoading";
import useDecodedParams from "Hooks/useDecodedParams";
import { organizationByDescriptionIdSelector } from "Reducers/organization";
import {
  getVouchers,
  vouchersSelector,
  vouchersLoadingSelector
} from "Reducers/voucher";
import Layout from "src/organization/pages/billing/components/Layout";
import { useAppDispatch, useAppSelector } from "Store/hooks";

import EmptyVouchers from "../components/EmptyVouchers";
import VouchersList from "../components/VouchersList";

const List = () => {
  const dispatch = useAppDispatch();
  const { organizationId } = useDecodedParams<{ organizationId: string }>();

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );
  const vouchers = useAppSelector(
    state => vouchersSelector(state, { organizationId }) ?? []
  );
  const loading = useAppSelector(state =>
    vouchersLoadingSelector(state, { organizationId })
  );

  useEffect(() => {
    if (organization) {
      dispatch(getVouchers({ organization }));
    }
  }, [organization, dispatch]);
  const hasVouchers = useMemo(() => vouchers?.length > 0, [vouchers]);

  return (
    <Layout>
      <ContentLayout>
        {loading !== false ? (
          <Loading />
        ) : (
          <>
            {hasVouchers ? (
              <VouchersList vouchers={vouchers} />
            ) : (
              <EmptyVouchers />
            )}
          </>
        )}
      </ContentLayout>
    </Layout>
  );
};

export default List;
